import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class PageService {
	constructor(private http: HttpClient) { }

	list(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.page:list',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	default(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.page:default',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getPageAction(id: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.page:getPageAction',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getPageActionList(ids: any[], options: any = []): Observable<JSONRpcResponse> {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.page:getPageActionList',
				params: {
					ids: ids,
					options: options,
				},
			})
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	get(code: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.page:get',
			params: {
				code: code,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	};
	
	listbygroup(code: string, options: any = []): Observable<JSONRpcResponse> {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.page:listbygroup',
				params: {
					code: code,
					options: options,
				},
			})
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	};

	getMenuList( options: any = []): Observable<JSONRpcResponse> {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.page:menu',
				params: {
					options: options,
				},
			})
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	};
}
